/****************************************************
 * Module Name:  signUp.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { Component } from "react";
import { Box, Button, TextField, Tooltip, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { CloseSharp } from "@mui/icons-material";
import Select from "react-select";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Utility from "../../utility/utility";
import Constants from "../../utility/constants";
import UserProxy from "../../utility/proxy/manager/userProxy";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import DocumentTyeProxy from "../../utility/proxy/manager/documentTypeProxy";
import PhoneInput from "react-phone-input-2";
import { CitySelect, CountrySelect, StateSelect, GetCountries } from "react-country-state-city";

export class SignUp extends Component {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();

        this.state = {
            registerCompanyName: '',
            registerUserName: '',
            registerFirstName: '',
            registerMiddleName: '',
            registerLastName: '',
            registerPhoneNo: '',
            registerEmail: '',
            registerAddress: '',
            registerPhoneCode: '',
            registerPincode: '',
            registerFax: '',
            registerGSTNo: '',
            registerPANNo: '',
            registerEmergencyContactName: '',
            registerEmergencyPhoneNo: '',
            registerEmergencyAddress: '',
            registerPassword: '',
            registerConfirmPassword: '',

            showLocationLoadSpinner: false,
            locationOptions: [],
            selectedLocation: { value: 0, label: 'Select...' },

            showDocTypeLoadSpinner: false,
            DocTypeOptions: [],
            selectedDocType: '',

            docTypeandFileName: [],

            submitLoading: false,

            showValidationMessage: false,
            validateUserPresentSpinner: false,
            registerUserNameAvailable: undefined,

            validateEmailPresentSpinner: false,
            showEmailValidationMessage: false,
            registerEmailAvailable: undefined,

            registerUserNameValidationError: '',
            registerFirstNameValidationError: '',
            registerLastNameValidationError: '',
            registerPhoneNoValidationError: '',
            registerPhoneCodeValidationError: '',
            registerEmailValidationError: '',
            registerAddressValidationError: '',
            registerPincodeValidationError: '',
            registerLocationValidationError: '',
            registerPanNoValidationError: '',
            registerEmergencyPhoneNoValidationError: '',
            registerPasswordValidationError: '',
            registerConfirmPasswordValidationError: '',

            defaultCountryForPhoneCode: "",

            selectedCountry: "",
            selectedState: "",
            selectedCity: "",
            countryname: "",
            statename: "",
            cityname: "",
            countryid: 0,
            stateid: 0,
            cityid: 0,
            newphonecode: "",
            countryValidationError: "",

        };
        this.getAllLocationList(false);
        this.getAllDocumentTypeList(false);
        this.fetchPhoneCode();
    }

    getAllLocationList = (locationSpinner) => {
        locationSpinner && this.setState({ showLocationLoadSpinner: true });
        LocationProxy.GetAllLocationDetailMini((response) => {
            if (response) this.setAllLocationData(response)
            else {
                this.props.showSnackBar(Constants.APiFailErrorMessage, "error");
            }
        });
    };

    getAllDocumentTypeList = (documentTypeSpinner) => {
        documentTypeSpinner && this.setState({ showDocTypeLoadSpinner: true });
        DocumentTyeProxy.getAllDocumentType((responseData) => {
            if (responseData) this.setAllDocumentTypeData(responseData)
            else {
                this.props.showSnackBar(Constants.APiFailErrorMessage, "error");
            }
        })
    }

    fetchPhoneCode = () => {
        GetCountries().then((countries) => {
            const country1 = countries.find(
                (c) => String(c.phone_code) === this.state.registerPhoneCode
            );
            if (!country1) {
                this.setState({ registerPhoneCode: "91", defaultCountryForPhoneCode: "in", })
            } else {
                this.setState({
                    registerPhoneCode: String(country1.phone_code), defaultCountryForPhoneCode: String(country1.iso2.toLowerCase()),
                })
            }
        })
    }


    setAllLocationData = (res) => {
        if (res) {
            let optionsArray = [];
            optionsArray.push({ value: "*", label: "-- ANY --" })
            res.map((data) => {
                let option = { value: data.id, label: data.name + " | " + data.country }
                optionsArray.push(option);

                return true;
            })
            this.setState({ locationOptions: optionsArray, showLocationLoadSpinner: false, selectedLocation: optionsArray[0] })
        }
    }

    setAllDocumentTypeData = (res) => {
        if (res) {
            let optionsArray = [];
            let tempArray = [];
            res.map((data) => {
                let tempObj = {};
                let option = { value: data.id, label: data.type }
                optionsArray.push(option);
                tempObj[data.type] = null;
                tempArray.push(tempObj);
                return true;
            })
            this.setState({ DocTypeOptions: optionsArray, showDocTypeLoadSpinner: false, docTypeandFileName: tempArray })
        }
    }
    validateUserPresent = (username) => {
        if (!username || username.trim() === "") return;

        this.setState({
            validateUserPresentSpinner: true,
        });

        UserProxy.CheckUserNameAvailable(username, (response) => {
            //if we got response that means user is present at backend
            if (response) {
                //Username already present
                this.setState({
                    validateUserPresentSpinner: false,
                    showValidationMessage: true,
                    registerUserNameAvailable: false,
                });
            } else {
                //Username not available, so can be used
                this.setState({
                    validateUserPresentSpinner: false,
                    showValidationMessage: true,
                    registerUserNameAvailable: true,
                });
            }
        });
    };

    validateEmailPresent = (email) => {
        if (!email || email.trim() === "") return;

        this.setState({
            validateEmailPresentSpinner: true,
        });

        UserProxy.checkUserEmailAvailable(email, (response) => {
            //if we got response that means email is present at backend
            if (response) {
                //Email already present
                this.setState({
                    validateEmailPresentSpinner: false,
                    showEmailValidationMessage: true,
                    registerEmailAvailable: false,
                });
            } else {
                //Username not available, so can be used
                this.setState({
                    validateEmailPresentSpinner: false,
                    showEmailValidationMessage: true,
                    registerEmailAvailable: true,
                })
            }
        })
    }

    handleRefClick = () => {
        this.fileInputRef.current.click();
    };

    handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            let tempTypeandFile = this.state.docTypeandFileName;
            if (this.state.selectedDocType.label !== null) {
                tempTypeandFile.map((item) => {
                    if (item.hasOwnProperty(this.state.selectedDocType.label)) {
                        item[this.state.selectedDocType.label] = file;
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            const base64String = reader.result
                            const commaIndex = base64String.indexOf(',');
                            const base64WithoutPrefix = base64String.substring(commaIndex + 1)
                            item["fileByteArray"] = base64WithoutPrefix;
                        };
                        reader.readAsDataURL(file);
                    }
                    return true;
                })
            }
            this.setState({ docTypeandFileName: tempTypeandFile, selectedDocType: '' });
        }
    }

    handleRemoveFile = (docType) => {
        const removeFileArray = this.state.docTypeandFileName;
        const indexToRemoveFile = this.state.docTypeandFileName.findIndex((item) => {
            return Object.keys(item)[0] === docType;
        })
        if (indexToRemoveFile !== -1) {
            if (removeFileArray[indexToRemoveFile] && removeFileArray[indexToRemoveFile].hasOwnProperty(docType)) {
                removeFileArray[indexToRemoveFile][docType] = null;
                removeFileArray[indexToRemoveFile]["fileByteArray"] = null;
            }
        }
        this.setState({
            docTypeandFileName: removeFileArray,
        })
    }

    handleSubmit = () => {
        if (!this.state.registerUserNameAvailable ||
            !this.state.registerEmailAvailable ||
            this.submitBtnDisable()) {
            this.validateUserPresent(this.state.registerUserName);
            this.validateEmailPresent(this.state.registerEmail);

            return;
        }

        let tempUserDocUploadArray = [];
        let dummyFunction = (item) => {
            let tempVariable = 0;
            this.state.DocTypeOptions.map((data) => {
                if (data.label === item) {
                    tempVariable = data.value;
                }
                return true;
            });
            return tempVariable;
        }

        this.state.docTypeandFileName.map((item) => {
            if (Object.values(item)[0] !== null) {
                let tempUserDocObj = {
                    docid: dummyFunction(Object.keys(item)[0]),
                    doctype: Object.keys(item)[0],
                    doc: Object.values(item)[1],
                    filename: Object.values(item)[0].name,
                    username: this.state.registerUserName ? this.state.registerUserName : '',
                }
                tempUserDocUploadArray.push(tempUserDocObj);
            }
            return true;
        });

        let submitData = {
            companyname: this.state.registerCompanyName.trim(),
            username: this.state.registerUserName,
            first_name: this.state.registerFirstName,
            middle_name: this.state.registerMiddleName,
            last_name: this.state.registerLastName,
            email: this.state.registerEmail,
            phone: this.state.registerPhoneNo,
            phonecode: this.state.registerPhoneCode,
            address: this.state.registerAddress,
            city: this.state.cityname,
            state: this.state.statename,
            country: this.state.countryname,
            pincode: this.state.registerPincode,
            fax: this.state.registerFax,
            gstinno: this.state.registerGSTNo,
            panno: this.state.registerPANNo,
            emergencycontactname: this.state.registerEmergencyContactName,
            emergencyphone: this.state.registerEmergencyPhoneNo,
            emergencyaddress: this.state.registerEmergencyAddress,
            locationid: this.state.selectedLocation.value === "*"
                ? (() => {
                    const foundLocation = this.state.locationOptions.find((ele) =>
                        ele.label.includes(Constants.DEFAULT_LOCATION)
                    );
                    return foundLocation ? foundLocation.value : null;
                })()
                : this.state.selectedLocation.value,
            userdoc: tempUserDocUploadArray,
            password: btoa(this.state.registerPassword),

        }
        UserProxy.signUp(submitData, (res) => {
            this.setState({ submitLoading: true });
            if (res) {
                this.setState({
                    submitLoading: false,
                });

                this.props.showSnackBar("Accocunt Registration is Successful, Please wait for Pansuriya Admin to APPROVE your Account", "success");
                this.props.closeDrawer();
            } else {
                this.setState({
                    submitLoading: true,
                });
                this.props.showSnackBar(Constants.APiFailErrorMessage, "error");
            }
        })

    }

    submitBtnDisable = () => {
        if (this.state.registerUserName.trim().length === 0 ||
            this.state.registerFirstName.trim().length === 0 ||
            this.state.registerPhoneNo.trim().length === 0 ||
            this.state.registerEmail.trim().length === 0 ||
            this.state.countryname.trim().length === 0 ||
            this.state.registerLastName.trim().length === 0 ||
            !this.state.registerUserNameAvailable ||
            !this.state.registerEmailAvailable ||
            this.state.registerUserNameValidationError.length > 0 ||
            this.state.registerFirstNameValidationError.length > 0 ||
            this.state.registerPhoneNoValidationError.length > 0 ||
            this.state.registerPhoneCodeValidationError.length > 0 ||
            this.state.registerEmailValidationError.length > 0 ||
            this.state.countryValidationError.length > 0 ||
            this.state.registerLastNameValidationError.length > 0 ||

            this.state.registerCompanyName.trim().length === 0

        )
            return true;
        return false;
    }

    emailValidation = (e) => {
        let tEmail = e.target.value.replace(/\s/g, '').toLowerCase();

        this.setState({
            registerEmail: tEmail,
            showEmailValidationMessage: false,
            registerEmailValidationError: Utility.CheckIsEmail(tEmail)
                ? ""
                : "Enter valid Email Id",
        });

        if (e.key === 'Enter' || e.type === 'blur') {
            if (Utility.CheckIsEmail(tEmail)) {
                this.validateEmailPresent(tEmail);
            } else {
                this.setState({
                    registerEmailValidationError: "Enter valid Email Id",
                });
            }
        }
    }

    render() {
        return (
            <Box width={700} mb={2} ml={2} mr={2}
                sx={{
                    "& .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                        fontSize: "14px",
                        padding: "8px 14px"
                    },
                    "& .css-k4qjio-MuiFormHelperText-root.Mui-error": {
                        color: "red",
                        fontSize: "12px",
                        fontWeight: "600",
                        marginLeft: "2px"
                    },
                    "& .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                        border: "2px solid red",
                    },
                    "& .css-ahj2mt-MuiTypography-root": {
                        fontSize: "15px",
                        fontWeight: "500",
                        marginBottom: "2px"
                    }
                }}
            >
                <Typography
                    variant="body1"
                    gutterBottom
                    color={'error'}
                    sx={{
                        margin: "8px",
                        fontSize: "14px",
                        fontWeight: "600",
                        textAlign: "center"
                    }}>
                    Please fill the form completely, missing Information might lead to User Account Approval Delay.
                </Typography>

                <Box display={'flex'} flexDirection={'row'} marginTop={1.2} marginBottom={1.2}>
                    <Box display={'flex'} alignItems={'center'}>
                        <CloseSharp onClick={() => this.props.closeDrawer()} style={{ transform: 'rotate(180deg)', cursor: 'pointer', fontSize: "20px" }} />
                    </Box>
                    <Box display={'flex'} alignItems={'center'} justifyContent={'center'} alignSelf={'flex-end'} style={{ width: '100%' }}>
                        <Typography variant="h5" align="center" color={'primary'}>
                            Registration
                        </Typography>
                    </Box>
                </Box>

                {/* Company Name */}
                <Box
                    sx={{
                        "& .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                            fontSize: "14px",
                            padding: "8px 14px"
                        }
                    }}
                >
                    <Typography > Company Name  <span style={{ color: "red" }}>*</span></Typography>
                    < Box display={"flex"} alignItems={"center"}>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            placeholder="Enter Company Name"
                            value={this.state.registerCompanyName}
                            style={{ marginTop: 0, marginBottom: 0 }}
                            autoFocus
                            onChange={(e) =>
                                this.setState({
                                    registerCompanyName: e.target.value,
                                })
                            }
                        />
                    </Box >
                    <Typography color={'primary'} style={{ fontSize: "14px", fontWeight: "600", marginTop: "3px", marginLeft: "2px" }}>
                        Please Fill Legal Name as per Business Registration
                    </Typography>
                </Box>

                {/* Username & Email */}
                <Box
                    display={"flex"}
                    alignItems="flex-start"
                    gap={'10px'}
                    marginTop={'10px'}
                >
                    <Box width={"50%"}>
                        <Typography > Username <span style={{ color: "red" }}>*</span> </Typography>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            required
                            placeholder="Enter Username"
                            value={this.state.registerUserName}
                            autoFocus
                            onBlur={(e) =>
                                this.validateUserPresent(e.target.value)
                            }
                            style={{ marginTop: 0, marginBottom: 0 }}
                            onChange={(e) =>
                                this.setState({
                                    registerUserName: e.target.value.replace(' ', '').toLowerCase(),
                                    showValidationMessage: false,
                                    registerUserNameValidationError: Utility.CheckIsPresent(
                                        e.target.value
                                    )
                                        ? ""
                                        : "Username Cannot be Empty",
                                })
                            }
                            helperText={this.state.registerUserNameValidationError}
                            error={this.state.registerUserNameValidationError.length > 0}
                        />
                        {this.state.validateUserPresentSpinner ? (
                            <CircularProgress size="1rem" />
                        ) : !this.state.showValidationMessage ? (
                            <div />
                        ) : this.state.registerUserNameAvailable !== undefined && (this.state.registerUserNameAvailable ? (
                            <font style={{ fontSize: "14px", fontWeight: "500", color: "#4EC073" }}>Username available</font>
                        ) : (
                            <font style={{ fontSize: "14px", fontWeight: "500", color: "red" }}>Username not available</font>
                        ))}
                    </Box>

                    <Box width={"50%"}>
                        <Typography > Email Id <span style={{ color: "red" }}>*</span> </Typography>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            size="small"
                            placeholder="Enter Email Id"
                            value={this.state.registerEmail}
                            style={{ marginTop: 0, marginBottom: 0 }}
                            onChange={(e) => this.emailValidation(e)}
                            onBlur={(e) => { this.emailValidation(e) }}
                            onKeyDown={(e) => { this.emailValidation(e) }}
                            helperText={this.state.registerEmailValidationError}
                            error={this.state.registerEmailValidationError.length > 0}
                        />
                        {this.state.validateEmailPresentSpinner ? (
                            <CircularProgress size="1rem" />
                        ) : !this.state.showEmailValidationMessage ? (
                            <div />
                        ) : this.state.registerEmailAvailable !== undefined && (this.state.registerEmailAvailable ? (
                            <font style={{ fontSize: "14px", fontWeight: "500", color: "#4EC073" }}>Email available</font>
                        ) : (
                            <font style={{ fontSize: "14px", fontWeight: "500", color: "red" }}>Email not available</font>
                        ))}
                    </Box>
                </Box>

                {/* password & confirm password */}

                <Box
                    display={"flex"}
                    alignItems="flex-start"
                    gap={'10px'}
                    marginTop={'10px'}
                >
                    <Box width={"50%"}>
                        <Typography > Password <span style={{ color: "red" }}>*</span> </Typography>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            type="password"
                            required
                            style={{ marginTop: 0, marginBottom: 0 }}
                            placeholder="Enter Password"
                            value={this.state.registerPassword}
                            autoFocus
                            onChange={(e) =>
                                this.setState({
                                    registerPassword: e.target.value,
                                    registerPasswordValidationError: e.target.value.length >= 8
                                        ? ""
                                        : e.target.value.length === 0 ? "Password Cannot be Empty"
                                            : "The password must be at least 8 characters long.",
                                })
                            }
                            helperText={this.state.registerPasswordValidationError}
                            error={this.state.registerPasswordValidationError.length > 0}
                        />
                    </Box>

                    <Box width={"50%"}>
                        <Typography > Confirm Password <span style={{ color: "red" }}>*</span> </Typography>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            required
                            type="password"
                            placeholder="Re-Enter Password"
                            style={{ marginTop: 0, marginBottom: 0 }}
                            value={this.state.registerConfirmPassword}
                            autoFocus
                            onChange={(e) =>
                                this.setState({
                                    registerConfirmPassword: e.target.value,
                                    registerConfirmPasswordValidationError: e.target.value === this.state.registerPassword
                                        ? ""
                                        : "Passwords do not match"
                                })
                            }
                            helperText={this.state.registerConfirmPasswordValidationError}
                            error={this.state.registerConfirmPasswordValidationError.length > 0}
                        />
                    </Box>
                </Box>

                {/* First Name & Last Name */}
                <Box
                    display={"flex"}
                    alignItems="flex-start"
                    gap={'10px'}
                    marginTop={'10px'}
                >
                    <Box width={"50%"}>
                        <Typography > First Name <span style={{ color: "red" }}>*</span> </Typography>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            required
                            style={{ marginTop: 0, marginBottom: 0 }}
                            placeholder="Enter First Name"
                            value={this.state.registerFirstName}
                            autoFocus
                            onChange={(e) =>
                                this.setState({
                                    registerFirstName: e.target.value,
                                    registerFirstNameValidationError: Utility.CheckIsPresent(
                                        e.target.value
                                    )
                                        ? ""
                                        : "First Name Cannot be Empty",
                                })
                            }
                            helperText={this.state.registerFirstNameValidationError}
                            error={this.state.registerFirstNameValidationError.length > 0}
                        />
                    </Box>

                    <Box width={"50%"}>
                        <Typography > Last Name <span style={{ color: "red" }}>*</span> </Typography>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            placeholder="Enter Last Name"
                            style={{ marginTop: 0, marginBottom: 0 }}
                            value={this.state.registerLastName}
                            autoFocus
                            onChange={(e) =>
                                this.setState({
                                    registerLastName: e.target.value,
                                    registerLastNameValidationError: Utility.CheckIsPresent(
                                        e.target.value
                                    )
                                        ? ""
                                        : "Last Name Cannot be Empty",
                                })
                            }
                            helperText={this.state.registerLastNameValidationError}
                            error={this.state.registerLastNameValidationError.length > 0}
                        />
                    </Box>
                </Box>

                {/* Middle Name & Phone No  */}
                <Box
                    display={"flex"}
                    alignItems="flex-start"
                    gap={'10px'}
                    marginTop={'10px'}
                >
                    <Box width={"50%"}>
                        <Typography > Middle Name </Typography>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            placeholder="Enter Middle Name"
                            style={{ marginTop: 0, marginBottom: 0 }}
                            value={this.state.registerMiddleName}
                            autoFocus
                            onChange={(e) =>
                                this.setState({
                                    registerMiddleName: e.target.value,
                                })
                            }
                        />
                    </Box>

                    <Box width={"50%"} display="flex" alignItems="flex-start" gap="10px">

                        <Box width="125px" display="flex" flexDirection="column">
                            <Typography> Country Code  <span style={{ color: "red" }}>*</span></Typography>
                            <PhoneInput
                                key={this.state.registerPhoneCode}
                                country={this.state.defaultCountryForPhoneCode}
                                enableSearch={true}
                                value={this.state.registerPhoneCode}
                                defaultValue={this.state.registerPhoneCode}
                                onChange={(phonecode) => {
                                    this.setState({
                                        registerPhoneCode: phonecode,
                                        registerPhoneCodeValidationError: Utility.CheckIsPresent(phonecode)
                                            ? ""
                                            : "Phone code cannot be empty",
                                    });
                                }}
                                inputStyle={{
                                    width: "100%",
                                    height: "25px",
                                    padding: "16px 3px 18.5px 60px"
                                }}
                                inputProps={{
                                    onKeyDown: (e) => e.preventDefault(),
                                    placeholder: "",
                                    readOnly: true,
                                }}
                                helperText={this.state.registerPhoneCodeValidationError}
                                error={this.state.registerPhoneCodeValidationError.length > 0}
                            />
                        </Box>

                        <Box flex="1" display="flex" flexDirection="column">
                            <Typography > Phone No <span style={{ color: "red" }}>*</span> </Typography>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                size="small"
                                type="number"
                                placeholder="Enter Phone No"
                                value={this.state.registerPhoneNo}
                                style={{
                                    marginTop: 0,
                                    marginBottom: 0,
                                }}
                                autoFocus
                                onChange={(e) =>
                                    this.setState({
                                        registerPhoneNo: e.target.value.trim(),
                                        registerPhoneNoValidationError: Utility.CheckIsNumber(
                                            e.target.value.trim()
                                        ) && e.target.value.trim().length !== 0
                                            ? ""
                                            : "Phone No is invalid",
                                    })
                                }
                                helperText={this.state.registerPhoneNoValidationError}
                                error={this.state.registerPhoneNoValidationError.length > 0}
                            />
                        </Box>
                    </Box>
                </Box>
                {/* Address */}
                <Box marginTop={'10px'}>
                    <Typography > Address </Typography>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        size="small"
                        multiline
                        rows={3}
                        placeholder="Enter Address"
                        value={this.state.registerAddress}
                        style={{ marginTop: 0, marginBottom: 0 }}
                        autoFocus
                        onChange={(e) =>
                            this.setState({
                                registerAddress: e.target.value,
                                registerAddressValidationError: e.target.value
                                    ? ""
                                    : "Address Cannot be Empty",
                            })
                        }
                        helperText={this.state.registerAddressValidationError}
                        error={this.state.registerAddressValidationError.length > 0}
                    />
                </Box>

                {/*Country & City & State */}
                <Box
                    display={"flex"}
                    alignItems="flex-start"
                    gap={'10px'}
                    marginTop={'10px'}
                >
                    <Box width={"33%"}
                        sx={{
                            "& input": {
                                border: "none !important",
                                padding: "2px !important"
                            },
                            "& input:focus": {
                                outline: "none !important"
                            },
                            "& container": {
                                height: "41px",
                            },
                        }}>
                        <Typography > Country <sup style={{ color: "red" }}>*</sup></Typography>
                        <Box sx={{
                            "& .stdropdown-container": {
                                fontFamily: "'Twemoji Mozilla','Arial' !important"
                            },
                        }}>
                            <CountrySelect
                                key={this.state.countryid}
                                margin="normal"
                                size="small"
                                fullWidth
                                placeHolder="Select Country"
                                value={this.state.countryid}
                                defaultValue={this.state.selectedCountry}
                                onChange={(e) => {
                                    this.setState({
                                        selectedCountry: e,
                                        countryid: e.id,
                                        countryname: e.name,
                                        stateid: 0,
                                        cityid: 0,
                                        statename: "",
                                        cityname: "",
                                        selectedCity: "",
                                        selectedState: "",
                                        newphonecode: String(e.phone_code),
                                        countryValidationError: "",
                                        defaultCountryForPhoneCode: String(e.iso2.toLowerCase())
                                    });

                                }}
                                onBlur={(e) => {
                                    if (e.target.value === "") {
                                        this.setState({
                                            countryid: 0,
                                            stateid: 0,
                                            cityid: 0,
                                            countryname: "",
                                            statename: "",
                                            cityname: "",
                                            selectedCountry: "",
                                            selectedCity: "",
                                            selectedState: "",
                                            countryValidationError: "Please select Country",
                                        });
                                    } else {
                                        this.setState({
                                            countryValidationError: ""
                                        });
                                    }
                                }}

                            />
                            {this.state.countryValidationError && (
                                <Typography color="error" variant="caption">{this.state.countryValidationError}</Typography>
                            )}
                        </Box>
                    </Box>


                    <Box width={"33%"}
                        sx={{
                            "& input": {
                                border: "none !important",
                                padding: "2px !important"
                            },
                            "& input:focus": {
                                outline: "none !important"
                            },
                            "& container": {
                                height: "41px"
                            },
                        }}
                    >
                        <Typography > State </Typography>
                        <Box sx={{
                            "& .stdropdown-container": {
                                fontFamily: "'Arial' !important"
                            },
                        }}>
                            <StateSelect
                                key={this.state.countryid}
                                margin="normal"
                                size="small"
                                fullWidth
                                countryid={this.state.countryid}
                                defaultValue={this.state.selectedState}
                                placeHolder="Select State"
                                value={this.state.stateid || ''}
                                onChange={(e) => {
                                    this.setState({
                                        selectedState: e,
                                        stateid: e.id,
                                        statename: e.name,
                                        cityid: 0,
                                        cityname: "",
                                        selectedCity: "",
                                    })
                                }}
                                onClick={(e) => {
                                    if (this.state.countryid === 0) {
                                        this.props.showSnackBar("Please Select Country First", "warning");
                                    }
                                }}
                                onBlur={(e) => {
                                    if (e.target.value.trim() === "") {

                                        this.setState({
                                            stateid: 0,
                                            cityid: 0,
                                            statename: "",
                                            cityname: "",
                                            selectedCity: "",
                                            selectedState: "",
                                        });
                                    }
                                }}
                            />
                        </Box>
                    </Box>

                    <Box width={"33%"}
                        sx={{
                            "& input": {
                                border: "none !important",
                                padding: "2px !important"
                            },
                            "& input:focus": {
                                outline: "none !important"
                            },
                            "& container": {
                                height: "41px"
                            },
                        }}
                    >
                        <Typography > City </Typography>
                        <Box sx={{
                            "& .stdropdown-container": {
                                fontFamily: "'Arial' !important"
                            },
                        }}>
                            <CitySelect
                                key={`${this.state.countryid}-${this.state.stateid}`}
                                countryid={this.state.countryid}
                                stateid={this.state.stateid}
                                defaultValue={this.state.selectedCity}
                                margin="normal"
                                size="small"
                                fullWidth
                                placeHolder="Select City"
                                value={this.state.cityid}
                                onChange={(e) => {
                                    this.setState({
                                        selectedCity: e,
                                        cityid: e.id,
                                        cityname: e.name,
                                    })
                                }}
                                onClick={(e) => {
                                    if (this.state.countryid === 0) {
                                        this.props.showSnackBar("Please Select Country First", "warning");
                                    } else if (this.state.stateid === 0) {
                                        this.props.showSnackBar("Please Select State First", "warning");
                                    }
                                }}
                                onBlur={(e) => {
                                    if (e.target.value.trim() === "") {
                                        this.setState({
                                            cityid: 0,
                                            cityname: "",
                                            selectedCity: "",
                                        });
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                </Box>

                {/* Pincode & Fax */}
                <Box
                    display={"flex"}
                    alignItems="flex-start"
                    gap={'10px'}
                    marginTop={'10px'}
                >
                    <Box width={"50%"}>
                        <Typography > Pincode</Typography>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            size="small"
                            placeholder="Enter Pincode"
                            value={this.state.registerPincode}
                            style={{ marginTop: 0, marginBottom: 0 }}
                            autoFocus
                            onChange={(e) => {
                                this.setState({
                                    registerPincode: e.target.value,
                                    registerPincodeValidationError: e.target.value ? "" : "Pincode Cannot be Empty",
                                });
                            }}
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
                            }}
                            helperText={this.state.registerPincodeValidationError}
                            error={this.state.registerPincodeValidationError.length > 0}
                        />
                    </Box>

                    <Box width={"50%"}>
                        <Typography > Fax </Typography>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            type="number"
                            placeholder="Enter Fax"
                            value={this.state.registerFax}
                            style={{ marginTop: 0, marginBottom: 0 }}
                            autoFocus
                            onChange={(e) =>
                                this.setState({
                                    registerFax: e.target.value,
                                })
                            }
                        />
                    </Box>
                </Box>

                {/* GST No & PAN No */}
                <Box
                    display={"flex"}
                    alignItems="flex-start"
                    gap={'10px'}
                    marginTop={'10px'}
                >
                    <Box width={"50%"}>
                        <Typography > GST No</Typography>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            placeholder="Enter GST No"
                            value={this.state.registerGSTNo}
                            style={{ marginTop: 0, marginBottom: 0 }}
                            autoFocus
                            onChange={(e) =>
                                this.setState({
                                    registerGSTNo: e.target.value.trim(),
                                })
                            }
                        />
                    </Box>

                    <Box width={"50%"}>
                        <Typography > PAN No </Typography>
                        <TextField
                            margin="normal"
                            fullWidth
                            required
                            size="small"
                            placeholder="Enter PAN No"
                            value={this.state.registerPANNo}
                            style={{ marginTop: 0, marginBottom: 0 }}
                            autoFocus
                            onChange={(e) =>
                                this.setState({
                                    registerPANNo: e.target.value.replace(/[^\w\s]/gi, ""),
                                    registerPanNoValidationError: e.target.value
                                        ? ""
                                        : "Pan Number can't be empty",
                                })
                            }
                            helperText={this.state.registerPanNoValidationError}
                            error={this.state.registerPanNoValidationError.length > 0}
                        />
                    </Box>
                </Box>

                {/* Emergency Contact Name & Emergency Phone No */}
                <Box
                    display={"flex"}
                    alignItems="flex-start"
                    gap={'10px'}
                    marginTop={'10px'}
                >
                    <Box width={"50%"}>
                        <Typography > Emergency Contact Name </Typography>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            placeholder="Enter Emergency Contact Name"
                            value={this.state.registerEmergencyContactName}
                            style={{ marginTop: 0, marginBottom: 0 }}
                            autoFocus
                            onChange={(e) =>
                                this.setState({
                                    registerEmergencyContactName: e.target.value,
                                })
                            }
                        />
                    </Box>

                    <Box width={"50%"}>
                        <Typography > Emergency Phone No</Typography>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            type="number"
                            placeholder="Enter Emergency Phone No"
                            value={this.state.registerEmergencyPhoneNo}
                            style={{ marginTop: 0, marginBottom: 0 }}
                            autoFocus
                            onChange={(e) =>
                                this.setState({
                                    registerEmergencyPhoneNo: e.target.value.trim(),
                                    registerEmergencyPhoneNoValidationError: Utility.CheckIsNumber(
                                        e.target.value.trim()
                                    ) || e.target.value.trim().length === 0
                                        ? ""
                                        : "Emergency Phone No is invalid",
                                })
                            }
                            helperText={this.state.registerEmergencyPhoneNoValidationError}
                            error={this.state.registerEmergencyPhoneNoValidationError.length > 0}
                        />
                    </Box>
                </Box>

                {/* Emergency Address & Location */}
                <Box
                    display={"flex"}
                    alignItems="flex-start"
                    gap={'10px'}
                    marginTop={'10px'}
                >
                    <Box width={"50%"}>
                        <Typography > Emergency Address </Typography>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            multiline
                            rows={3}
                            placeholder="Enter Emergency Address"
                            value={this.state.registerEmergencyAddress}
                            style={{ marginTop: 0, marginBottom: 0 }}
                            autoFocus
                            onChange={(e) =>
                                this.setState({
                                    registerEmergencyAddress: e.target.value,
                                })
                            }
                        />
                    </Box>

                    <Box width={"50%"} sx={{
                        "& .css-b62m3t-container": {
                            width: "90%"
                        }
                    }}>
                        <Typography > Location </Typography>
                        <Box sx={{ display: "flex" }}>
                            <Select menuPlacement="auto"
                                blurInputOnSelect={false}
                                className="basic-single"
                                classNamePrefix="select"
                                value={this.state.selectedLocation}
                                isSearchable={true}
                                name="Location"
                                options={this.state.locationOptions}
                                onChange={(selectedOption) =>
                                    this.setState({ selectedLocation: selectedOption })
                                }
                                menuPortalTarget={document.body}
                                styles={Constants.Styles}
                            />
                            {this.state.showLocationLoadSpinner ? (
                                <CircularProgress size="1rem" sx={{ mt: 1 }} />
                            ) : (
                                <Tooltip title="Reload">
                                    <RefreshOutlinedIcon
                                        color="primary"
                                        fontSize="medium"
                                        onClick={() => this.getAllLocationList(true)}
                                        sx={{ cursor: "pointer", alignSelf: 'center', marginLeft: "10px" }}
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </Box>
                </Box>

                {/* Document Type */}
                <Box
                    display={"flex"}
                    alignItems="center"
                    gap={'10px'}
                    marginTop={'10px'}
                >
                    <Typography style={{ width: "20%" }}> Document Type </Typography>
                    <Box width={"50%"}>
                        <Select menuPlacement="auto"
                            blurInputOnSelect={false}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="Select Document Type"
                            menuPortalTarget={document.body}
                            styles={Constants.Styles}
                            value={this.state.selectedDocType}
                            onChange={(type) => this.setState({ selectedDocType: type })}
                            options={this.state.DocTypeOptions.filter((item) => {
                                return this.state.docTypeandFileName.some((type) => {
                                    return type[item.label] === null;
                                });
                            })
                            }
                        />
                    </Box>
                    {this.state.showDocTypeLoadSpinner ? (
                        <CircularProgress size="1rem" />
                    ) : (
                        <Tooltip title="Reload Document Type List">
                            <RefreshOutlinedIcon
                                color="primary"
                                fontSize="medium"
                                onClick={() => this.getAllDocumentTypeList(true)}
                                sx={{ cursor: "pointer", alignSelf: 'center' }}
                            />
                        </Tooltip>
                    )}
                    <Box width={'25%'}>
                        <input
                            type="file"
                            accept=".pdf, .jpg, .jpeg, .png, .bmp, .heif, .heic"
                            ref={this.fileInputRef}
                            style={{ display: 'none' }}
                            onChange={(e) => this.handleFileChange(e)}
                        />
                        <Tooltip title="Add New Document">
                            <Button
                                color="info"
                                variant="outlined"
                                size="small"
                                sx={{ ml: "10px" }}
                                onClick={() => this.handleRefClick()}
                                startIcon={<AddBoxOutlinedIcon size="large" />}
                                disabled={this.state.DocTypeOptions.length === 0 || this.state.selectedDocType === ""}
                            >
                                Add Document
                            </Button>
                        </Tooltip>
                    </Box>
                </Box>

                {/* Render selected file names */}
                <Typography variant="body1" sx={{ marginTop: "10px" }}>
                    Selected Files:
                    {this.state.docTypeandFileName.map((item) => {
                        const file = Object.values(item)[0];
                        const docType = Object.keys(item)[0];
                        return (
                            <div>
                                {file !== null ?
                                    <Typography variant='body1'>
                                        <span>{docType + " : " + file.name}</span>
                                        <CloseSharp onClick={() => this.handleRemoveFile(docType)} />
                                    </Typography> : null}
                            </div>
                        )
                    })}
                </Typography>

                <LoadingButton
                    fullWidth
                    variant={this.submitBtnDisable() ? "outlined" : "contained"}
                    loading={this.state.submitLoading}
                    onClick={() => this.handleSubmit()}
                    disabled={this.submitBtnDisable()}
                    sx={{ marginTop: 2 }}
                >
                    Submit
                </LoadingButton>
            </Box >
        )
    }
}